module.exports = __webpack_public_path__ + "static/media/amazon-us-icon.bb63d906.svg";